import { createContext } from 'react';
import type { AppUserInfo } from '@/models/AppViewModel';
import type { UserInterface } from '@/interfaces/user';

const emptyUser: UserInterface = { id: 0, name: '', role: '' };

export interface UserContextInterface {
  currentUser: UserInterface;
  setCurrentUser: (user: UserInterface) => void;
  currentRole: string;
  setCurrentRole: (role: string) => void;
  logout: () => void;
  isLoggedIn: boolean;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  isAuthenticated: boolean;
  authIsLoading: boolean;
  userInfo: AppUserInfo | null | undefined;
}

/** Default context value; exported for tests/stories that need to mock UserContext. */
export const defaultUserContextValue: UserContextInterface = {
  currentUser: emptyUser,
  setCurrentUser: () => {},
  logout: () => {},
  currentRole: '',
  setCurrentRole: () => {},
  isLoggedIn: false,
  setIsLoggedIn: () => {},
  isAuthenticated: false,
  authIsLoading: false,
  userInfo: null,
};

export const UserContext = createContext<UserContextInterface>(
  defaultUserContextValue,
);

export { emptyUser };
